export default __webpack_public_path__ + "static/media/logo.d01cecd3.jpg";